import React, {memo, useState} from 'react'
import {TModuleListHeaders, TModuleListRow} from '../_types'
import {useFormikContext} from 'formik'
import ComponentCheckbox from '../../../components/ComponentCheckbox'
import {CardCell} from './CardCell'


export const ListCard: React.FC<TModuleListRow> = memo(props => {
    const { data, headers, page, filterKeys, isListEditable, setFilter, setIndividualPage, isNewUI } = props
    const { values, setFieldValue } = useFormikContext<{ selectedItems: Array<any> }>()
    const [ isExpanded, setIsExpanded ] = useState(false)

    // Разделяем контентные поля и кнопки
    const default_visible_fields = 4
    const actionHeader = headers.find(h => h.type === 'buttons' || h.article === 'buttons')
    const dataHeaders = headers.filter(h => h !== actionHeader)
    const visibleHeaders = isExpanded ? dataHeaders : dataHeaders.slice(0, default_visible_fields)

    const renderCells = (cells : TModuleListHeaders) => (
        cells.map(cell => (
            <div className="moduleList_cardRow" key={cell.article}>
                <div className="moduleList_cardLabel" style={{whiteSpace: "normal"}}>
                    {cell.title}
                </div>
                <div className="moduleList_cardValue">
                    <CardCell
                        article={cell.article}
                        type={cell.type}
                        row={data}
                        page={page}
                        filterable={filterKeys.includes(cell.article)}
                        setFilter={setFilter}
                        setIndividualPage={setIndividualPage}
                        suffix={cell.suffix}
                        isNewUI={isNewUI}
                        is_hex={cell.is_hex}
                    />
                </div>
            </div>
        ))
    )

    const { selectedItems } = values
    const isCheckboxEnabled = Boolean(data.id)
    const indexOfRow = isCheckboxEnabled ? selectedItems.findIndex(selectedItem => selectedItem.id === data.id) : -1
    const isRowChecked = indexOfRow !== -1

    const handleDeleteCheckboxClick = () => {
        if (!isCheckboxEnabled) {
            return
        }

        const itemsToDeleteClone = [...selectedItems]
        if (isRowChecked) {
            itemsToDeleteClone.splice(indexOfRow, 1)
        } else {
            itemsToDeleteClone.push(data)
        }
        return setFieldValue("selectedItems", itemsToDeleteClone)
    }

    return <div className={`moduleList_card ${isRowChecked ? " selected" : ""}`} >
        {
            isListEditable ? <div className="moduleList_cardDelCheckbox deleteCheckbox">
                <ComponentCheckbox customChecked={isRowChecked} customHandler={handleDeleteCheckboxClick} is_disabled={!isCheckboxEnabled}/>
            </div> : null
        }
        <div className="moduleList_cardBody">
            {renderCells(visibleHeaders)}

             {/*Кнопка "Подробнее" */}
            {dataHeaders.length > 4 && (
                <div className="moduleList_cardMore">
                    <button className="componentButton  secondary" type="button" onClick={() => {setIsExpanded(prev => !prev)}}>
                        {isExpanded ? 'Скрыть' : 'Подробнее'}
                    </button>
                </div>
            )}

            {/* Кнопки действий (если есть) */}
            {actionHeader && (
                <div className="moduleList_cardActions">
                    <CardCell
                        article={actionHeader.article}
                        type={actionHeader.type}
                        row={data}
                        page={page}
                        filterable={false}
                        setFilter={setFilter}
                        setIndividualPage={setIndividualPage}
                        isNewUI={isNewUI}
                    />
                </div>
            )}
        </div>
    </div>
})